import {
  Competition,
  CompetitionRuleId,
  CompetitionStatus,
  CompetitionType,
} from '../../../../features/Competition/types';
import {
  TradingCompetitionResponse,
  TradingCompetitionResponseLeaderboardTypeEnum,
  TradingCompetitionResponseStatusEnum,
} from '../../generated';

const toMsTimestamp = (t?: number) => {
  if (typeof t !== 'number') return t;
  // Heuristic: seconds timestamps are ~1e9-1e10, ms timestamps are ~1e12-1e13
  return t < 1_000_000_000_000 ? t * 1000 : t;
};

export const toCompetition = (
  response: TradingCompetitionResponse,
): Competition => {
  let type = CompetitionType.VOLUME;
  if (
    response.leaderboardType ===
    TradingCompetitionResponseLeaderboardTypeEnum.PnlBased
  ) {
    type = CompetitionType.PNL;
  }

  let status = CompetitionStatus.ONGOING;
  if (response.status === TradingCompetitionResponseStatusEnum.Upcoming) {
    status = CompetitionStatus.UPCOMING;
  } else if (response.status === TradingCompetitionResponseStatusEnum.Ended) {
    status = CompetitionStatus.ENDED;
  }

  return {
    id: response.id,
    title: response.title || '',
    description: response.description,
    banner: response.banner,
    type,
    status,
    tradingVolume: response.tradingVolume ?? 0,
    startTime: toMsTimestamp(response.startTime)!,
    endTime: toMsTimestamp(response.endTime)!,
    rewardAmount: response.rewardAmount,
    rewardTokenAddress: response.rewardTokenAddress,
    rewardDescription: response.rewardDescription,
    ruleLink: response.ruleLink,
    ruleId: (response.ruleId as CompetitionRuleId) ?? CompetitionRuleId.DEFAULT,
    currentParticipants: response.currentParticipants ?? 0,
    hasJoined: response.hasJoined ?? false,
  };
};

